import {IVersionInformation} from "./IVersionInformation";
/**
 * Created with IntelliJ IDEA.
 * User: sronge
 * Date: 06.05.13
 * Time: 09:00
 * To change this template use File | Settings | File Templates.
 */
import {BasicLanguageVersion} from "./version/BasicLanguageVersion";
import {BasicVersions} from "./version/BasicVersions";
import {LanguageData, TextsParser} from "@goodgamestudios/localization";

export class VersionInformation implements IVersionInformation {
    private static _itemXmlVersion: string;
    private static _languageXmlVersion: string;
    private static _versionInstance: VersionInformation;
    private static _buildNumberServer: string;
    protected _additionalItemXMLInfo: string = "";
    protected _additionalLanguageXMLInfo: string = "";

    public static get versionInstance(): VersionInformation {
        if (!VersionInformation._versionInstance) {
            VersionInformation._versionInstance = new VersionInformation();
        }
        return VersionInformation._versionInstance;
    }

    // TODO: @HTML5 XML Management
    public /*final*/ parseItemXML(xmlData: any): void {
        let xmlList: any = xmlData.child("versionInfo");
        this.itemXmlVersion = xmlList.attribute("version");
        this.parseAdditionlItemXMLVersionInfo(xmlList);
    }

    public /*final*/ parseLanguageXml(json: LanguageData): void {
        VersionInformation._languageXmlVersion = TextsParser.parseVersionNo(json) + "|" + TextsParser.parseDeployTime(json);
    }

    /**
     * Hook method
     */
    // TODO: @HTML5 XML Management
    protected parseAdditionlItemXMLVersionInfo(xmlList: any): void {

    }

    public get itemXmlVersion(): string {
        return VersionInformation._itemXmlVersion;
    }

    public set itemXmlVersion(value: string) {
        VersionInformation._itemXmlVersion = value;
    }

    public get languageXmlVersion(): string {
        return VersionInformation._languageXmlVersion;
    }

    public set languageXmlVersion(value: string) {
        VersionInformation._languageXmlVersion = value;
    }

    public /*final*/ get versionNumberItemXMLString(): string {
        return this.itemXmlVersion + this._additionalItemXMLInfo;
    }

    public /*final*/ get versionNumberLanguageXMLString(): string {
        return this.itemXmlVersion + this._additionalLanguageXMLInfo;
    }


    public get buildNumberGame(): string {
        return null;
    }

    public get versionNumberGame(): string {
        return null;
    }

    public get buildNumberServer(): string {
        return VersionInformation._buildNumberServer;
    }

    public set buildNumberServer(value: string) {
        VersionInformation._buildNumberServer = value;
    }

    public get basicVersionNumberItemsXML(): string {
        return BasicVersions.itemXMLVersion;
    }

    public get basicVersionNumberLanguageXML(): string {
        return BasicLanguageVersion.VERSION;
    }

    protected get formatVersionNumberGame(): string {
        return "V" + this.versionNumberGame;
    }

    protected get formatBuildNumberGame(): string {
        return " B" + this.buildNumberGame;
    }

    protected get formatItemXmlVersionNumber(): string {
        if (!VersionInformation._itemXmlVersion) {
            return "";
        }
        return " iXML" + VersionInformation._itemXmlVersion;
    }

    protected get formatBuildNumberServer(): string {
        if (!VersionInformation._buildNumberServer) {
            return "";
        }
        return " S" + VersionInformation._buildNumberServer;
    }

    protected get formatLanguageVersionNumber(): string {
        // We will not show language version and timestamp on test servers
        // let isTestServer: boolean = BasicModel.instanceProxy.selectedInstanceVO && NetworkInstance.isTestInstance(BasicModel.instanceProxy.selectedInstanceVO.instanceId);
        // if (!VersionInformation._languageXmlVersion || !isTestServer) {
        //     return "";
        // }

        return " lXML" + this.languageXmlVersion;
    }

    public get versionText(): string {
        return this.getVersionText();
    }

    public getVersionText() {
        return this.formatVersionNumberGame + this.formatBuildNumberGame + this.formatBuildNumberServer + this.formatItemXmlVersionNumber + this.formatLanguageVersionNumber;
    }
}

